// Governance cockpits — TanStack Query hooks for the cross-portfolio
// work queues. Read-only; mutations happen on the owning loan tabs.

import { useQuery } from "@tanstack/react-query";
import { workQueuesApi } from "@/api/compliance/client";

// Work queues are a live triage surface — opt out of the 5-minute global
// staleTime so re-entering a cockpit refetches within a minute.
const WORK_QUEUE_STALE_MS = 60_000;

export const workQueueKeys = {
  compliance: ["compliance", "work-queue"] as const,
  qa: ["compliance", "qa-work-queue"] as const,
  defaults: ["compliance", "defaults-work-queue"] as const,
};

export function useComplianceWorkQueue() {
  return useQuery({
    queryKey: workQueueKeys.compliance,
    queryFn: () => workQueuesApi.compliance(),
    staleTime: WORK_QUEUE_STALE_MS,
  });
}

export function useQaWorkQueue() {
  return useQuery({
    queryKey: workQueueKeys.qa,
    queryFn: () => workQueuesApi.qa(),
    staleTime: WORK_QUEUE_STALE_MS,
  });
}

export function useDefaultsWorkQueue() {
  return useQuery({
    queryKey: workQueueKeys.defaults,
    queryFn: () => workQueuesApi.defaults(),
    staleTime: WORK_QUEUE_STALE_MS,
  });
}
